import { Id } from '@common/types';
import useWaitingMutation from '@common/hooks/useWaitingMutation';
import { reinstateProduct } from '@common/services/submissionService';
import { useParams } from 'react-router';

interface Props {
  productId: Id;
}

export const useReinstateProduct = () => {
  const { submissionId = '' } = useParams();

  const { mutate, isLoading } = useWaitingMutation(({ productId }: Props) => reinstateProduct(submissionId, productId));

  return { reinstateProduct: mutate, isReinstatingProduct: isLoading };
};
